import React, { useState } from 'react'
import { Typography } from '@mui/material'
import { ChevronLeft, ChevronRight } from '@mui/icons-material'
import { EventsTypes } from '../../interfaces/types'
import { CarouselWrapper, EventTitle, DesktopEventTitle, EventDescription, CarouselContainer, CarouselOverlay, CarouselImage, StyledIconButton, ContentRow, TextBlock, MobileTitle } from '../../styles/EventsPages/EventsSection'

interface PrivateEventsSectionProps {
  eventsType: EventsTypes;
  side: 'left' | 'right';
}

const PrivateEventsPictureGallery: React.FC<PrivateEventsSectionProps> = ({ eventsType, side }) => {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  const handleNextImage = () => {
    setCurrentImageIndex((prevIndex) =>
      prevIndex === eventsType.images.length - 1 ? 0 : prevIndex + 1
    );
  };

  const handlePrevImage = () => {
    setCurrentImageIndex((prevIndex) =>
      prevIndex === 0 ? eventsType.images.length - 1 : prevIndex - 1
    );
  };

  const currentImage = eventsType.images[currentImageIndex];

  return (
    <CarouselWrapper>
      <ContentRow side={side}>
        <MobileTitle>
          <EventTitle>{eventsType.title}</EventTitle>
        </MobileTitle>
        <CarouselContainer>
          <CarouselImage src={currentImage.src} alt={`${eventsType.title} - ${currentImage.location}`} />
          <CarouselOverlay>
            <Typography variant="caption">
              {currentImage.date} - {currentImage.location}
            </Typography>
          </CarouselOverlay>

          {/* Left Arrow */}
          <StyledIconButton
            onClick={handlePrevImage}
            sx={{ left: '10px' }}
          >
            <ChevronLeft />
          </StyledIconButton>

          {/* Right Arrow */}
          <StyledIconButton
            onClick={handleNextImage}
            sx={{ right: '10px' }}
          >
            <ChevronRight />
          </StyledIconButton>

        </CarouselContainer>

        <TextBlock>
          <DesktopEventTitle>{eventsType.title}</DesktopEventTitle>
          <EventDescription>{eventsType.description}</EventDescription>
        </TextBlock>
      </ContentRow>
    </CarouselWrapper>
  );
};

export default PrivateEventsPictureGallery;
